<script setup>
import { ref, computed, onMounted, watch, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { supabase } from '@/supabase';

import MultiSelect from 'primevue/multiselect';
import Textarea from 'primevue/textarea';
import Button from 'primevue/button';
import Avatar from 'primevue/avatar';
import Panel from 'primevue/panel'
import Dialog from 'primevue/dialog';
import Chip from 'primevue/chip';
import InputSwitch from 'primevue/inputswitch';
import { useGlobalToast } from '@/composables/useGlobalToast';
const { showToast } = useGlobalToast();
import { replaceEspacosPorHTML } from '@/utils/replaceEspacosPorHTML';
import { copiarConteudo } from '@/utils/copiarConteudo';
import FiltrosCadernoComponent from "./FiltrosCadernoComponent.vue"

import { formatarDataHora } from '@/utils/formatarDataHora';
import { storeToRefs } from 'pinia';
import { useCadernoStore } from './useCardernoStore';
import ComentarioEmMassaComponent from './ComentarioEmMassaComponent.vue';
import InputComentarioAnotacaoComponent from './InputComentarioAnotacaoComponent.vue';
import FeedbackDoFeedbackComponent from './FeedbackDoFeedbackComponent.vue';
const store = useCadernoStore();
const { anotacoes, alunosSemAnotacoes } = storeToRefs(store);



onMounted(async () => {
    await store.listarAnotacoes();
})

onUnmounted(()=> {
    anotacoes.value = [];
})


function mostrarTodasAsAnotacoesDoAluno(id) {
    anotacoes.value.map(estudante => {
        if (estudante.id == id) {
            estudante.anotacoes.map(a => {
                if (a.condicao == 'ocultar') {
                    a.condicao = 'exibir'
                }
            })
        }
    })
}


function copiar(){
    copiarConteudo(anotacoes.value)
    showToast({ detail: 'As anotações foram copiadas', life: 3000 })
}

</script>

<template>
    <div style="padding-top: 70px!important;margin-bottom: 30px;">
        <div class="grid ">
            <div class="col-12 lg:col-4 p-3 lg:p-5">
                <div class="flex flex-column gap-4">
                    <FiltrosCadernoComponent />

                </div>
                <div class="hidden lg:block mt-5">
                    <ComentarioEmMassaComponent />
                </div>
            </div>
            <div class="col-12 lg:col-8 p-3 lg:p-5">

                <div>
                    <div class="flex justify-content-end">
                        <Button label="Copiar" icon="pi pi-copy" class="ml-2" text @click="copiar" />
                    </div>
                    <div v-for="anotacao in anotacoes" :key="anotacao.id">
                        <div v-if="anotacao.anotacoes.length > 0 || alunosSemAnotacoes == true"
                            class="mb-5 flex flex-column  gap-3">
                            <div class="flex gap-3 align-items-center">
                                <img :src="anotacao.imagem" :alt="anotacao.nome"
                                    style="min-width:60px; min-height: 60px; max-width:60px; max-height: 60px; border-radius:50%; object-fit: cover;">
                                <div class="flex flex-column gap-1">
                                    <div class="text-lg font-medium mb-1">{{ anotacao.nome }}</div>
                                    <div class="text-sm"> {{ anotacao.anotacoes.length }} {{ anotacao.anotacoes.length
                                        === 1 ?
                                        'anotação' : 'anotações' }}</div>
                                </div>
                            </div>
                            <div class="flex flex-column gap-3">

                                <div v-for="nota in anotacao.anotacoes" :key="nota.id">

                                    <div v-if="nota.condicao == 'exibir'"
                                        class="bg-white border-1 border-surface surface-border border-round">
                                        <div class="p-3 flex justify-content-between">
                                            <div>
                                                <div>{{ nota.titulo }}</div>
                                                <div class="text-sm mb-2">{{ formatarDataHora(nota.data) }}</div>
                                            </div>
                                            <FeedbackDoFeedbackComponent :feedback="nota.feedback_comentario" class="hidden md:block"/>
                                        </div>

                                        <div class="p-3 pt-0" v-if="nota.anotacao !== ''"
                                            v-html="replaceEspacosPorHTML(nota.anotacao)">
                                        </div>
                                        <div class="surface-ground">
                                            <div class="p-3">
                                                <InputComentarioAnotacaoComponent
                                                    :comentarioSalvo="nota.comentarioSalvo" :idAnotacao="nota.id"
                                                    v-model="nota.comentario" />
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>

                            <div v-if="anotacao.anotacoes.some(anotacao => anotacao.condicao == 'ocultar')"
                                class="flex justify-content-center">
                                <Button label="Mostrar mais" severity="secondary" text
                                    v-tooltip.top="'Mostrar todas as anotações'"
                                    @click="mostrarTodasAsAnotacoesDoAluno(anotacao.id)" />
                            </div>
                        </div>
                    </div>
                    <div v-if="anotacoes.length === 0 && alunosSemAnotacoes">
                        <div>Todos os alunos tem alguma anotação no período selecionado. Experimente selecionar uma data
                            específica.</div>
                    </div>
                </div>
            </div>
        </div>


    </div>

</template>





<style >
.panel-lembrete .p-panel-header {
    background-color: #fff
}
.lembrete-texto br{
    content: "";
        display: block;
        margin-top: 10px;
}
</style>